import React from 'react'

import * as S from './styled'

export type Props = {
  quantity: number | string
}

export const QuantityBadge = ({ quantity }: Props) => <S.Container>{quantity}</S.Container>
